import React, { useState } from 'react'
import {
  TextInput,
  SimpleForm,
  required,
  AutocompleteInput,
  Create,
  FormDataConsumer,
  minLength,
} from 'react-admin'

import { useDispatch } from 'react-redux'

import { Grid, Paper, Button, Typography, makeStyles } from '@material-ui/core'

import { ResourceSelector, DatetimePicker } from 'components'
import { formatDate, addHoursDate } from 'utils/date'
import { numberValidate } from 'utils/formValidations'
import * as actions from 'customReducers/courseReducer/actions'

import { Tooltip } from 'components'

const useStyles = makeStyles({
  container: {
    width: '100%',
  },
  formContainer: {
    backgroundColor: '#F5F5F5',
  },
  paperContainer: {
    padding: 16,
  },
  buttonsContainer: {
    padding: 8,
  },
  contentPaddingBottom: {
    marginBottom: 12,
  },
  contentPaddingTop: {
    marginTop: 12,
  },
})

export const CreateForm = (props: any) => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const { setFormData, toolbar, aside, ...rest } = props

  const [tags, setTags] = useState([1])
  const [attachments, setAttachments] = useState([1])
  const [involvedPersons, setInvolvedPersons] = useState([1])

  let dateNow: string | Date = addHoursDate({ amount: 3 })
  dateNow = formatDate({ date: dateNow })

  return (
    <Create
      // aside={aside}
      {...rest}
    >
      <SimpleForm
        warnWhenUnsavedChanges
        className={classes.formContainer}
        toolbar={toolbar}
      >
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          spacing={2}
          className={classes.container}
        >
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Paper className={classes.paperContainer}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography variant="h5" color="textSecondary" gutterBottom>
                  Inserir Novo Curso
                </Typography>
                <hr />
                <Typography
                  variant="subtitle1"
                  color="textPrimary"
                  gutterBottom
                >{`Configurações: `}</Typography>
              </Grid>

              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                  <Tooltip title={'courses.released_at'}>
                    <DatetimePicker
                      fullWidth
                      source="released_at"
                      label="Lançamento"
                      validate={[required('Obrigatório')]}
                    />
                  </Tooltip>
                </Grid>

                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <Tooltip title={'courses.order'}>
                    <TextInput
                      fullWidth
                      label="Ordem"
                      source="order"
                      validate={[
                        required('Obrigatório'),
                        numberValidate,
                        minLength(2, 'Mínimo 2 caracteres numéricos'),
                      ]}
                    />
                  </Tooltip>
                </Grid>
              </Grid>

              <Grid container spacing={2} direction="column">
                <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                  <Tooltip title={'courses.type'}>
                    <AutocompleteInput
                      fullWidth
                      label="Tipo"
                      source="catalog_type"
                      choices={[
                        { id: 'case', name: 'Curso' },
                        { id: 'serie', name: 'Série' },
                      ]}
                      validate={[required('Obrigatório')]}
                    />
                  </Tooltip>
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Tooltip title={'courses.title'}>
                    <TextInput
                      fullWidth
                      label="Título"
                      source="title"
                      validate={[required('Obrigatório')]}
                    />
                  </Tooltip>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <hr />
                  <Typography
                    variant="subtitle1"
                    color="textPrimary"
                    gutterBottom
                  >{`Tema do curso ou série: `}</Typography>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    display="block"
                  >
                    {`As cores precisam ser cadastradas previamente. Insira o código Hexadecimal da cor já cadastrada para vincular, ou clique em [Criar Novo Tema].`}
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                  <ResourceSelector
                    fullWidth
                    label="Cor primária"
                    source={`contents.stylesheets[0].id`}
                    resource="cms/content/stylesheets"
                    optionValue="id"
                    choicesFilter={{
                      target: 'type',
                      filter: 'primary',
                    }}
                    validate={[required('Obrigatório')]}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                  <ResourceSelector
                    fullWidth
                    label="Cor inicial do gradiente"
                    source={`contents.stylesheets[1].id`}
                    resource="cms/content/stylesheets"
                    optionValue="id"
                    choicesFilter={{
                      target: 'type',
                      filter: 'gradient_start',
                    }}
                    validate={[required('Obrigatório')]}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                  <ResourceSelector
                    fullWidth
                    label="Cor final do gradiente"
                    source={`contents.stylesheets[2].id`}
                    resource="cms/content/stylesheets"
                    optionValue="id"
                    choicesFilter={{
                      target: 'type',
                      filter: 'gradient_end',
                    }}
                    validate={[required('Obrigatório')]}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => dispatch(actions.stylesheetsDialog())}
                    className={classes.contentPaddingBottom}
                  >
                    Criar novo Tema
                  </Button>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <hr />
                <Typography
                  variant="subtitle1"
                  color="textPrimary"
                  gutterBottom
                >{`Card da home: `}</Typography>
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Tooltip title={'courses.subtitle'}>
                  <TextInput
                    fullWidth
                    label="Nome da empresa"
                    source="subtitle"
                    validate={[required('Obrigatório')]}
                  />
                </Tooltip>
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Tooltip title={'courses.summary.title'}>
                  <TextInput
                    fullWidth
                    label="Título do curso (home)"
                    source="summary"
                    validate={[required('Obrigatório')]}
                  />
                </Tooltip>
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <hr />
                <Typography
                  variant="subtitle1"
                  color="textPrimary"
                  gutterBottom
                >{`Poster de Listagem: `}</Typography>
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Typography
                  variant="subtitle2"
                  color="textPrimary"
                >{`Para o Poster: `}</Typography>
                <Typography variant="caption" color="textSecondary">
                  {` Digite uma parte do nome da Imagem que você deseja vincular. Este é o Poster do curso/série na listagem da Home.`}
                </Typography>
                <hr />
                <Tooltip title={'courses.images.poster'}>
                  <ResourceSelector
                    fullWidth
                    label="Poster"
                    resource="cms/content/images"
                    source="contents.images[0].id"
                    optionValue="id"
                    validate={[required('Obrigatório')]}
                    choicesFilter={{
                      target: 'type',
                      filter: 'poster',
                    }}
                  />
                </Tooltip>
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Typography
                  variant="subtitle2"
                  color="textPrimary"
                >{`Para o Marcador: `}</Typography>
                <Typography variant="caption" color="textSecondary">
                  {` Digite uma parte do nome do Marcador que você deseja vincular.`}
                </Typography>
                <Typography variant="caption" color="textSecondary">
                  {` Este é a indicação para conteúdos novos posicionado no Poster.`}
                </Typography>
                <hr />

                <ResourceSelector
                  fullWidth
                  label="Marcador"
                  source="contents.marks[0].id"
                  resource="cms/content/marks"
                  optionValue="id"
                  validate={[required('Obrigatório')]}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                className={classes.contentPaddingBottom}
              >
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => dispatch(actions.marksDialog())}
                >
                  Criar Novo Marcador
                </Button>
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                className={classes.contentPaddingTop}
              >
                <hr />
                <Typography
                  variant="subtitle1"
                  color="textPrimary"
                  gutterBottom
                >{`Banner da Página de Curso/Série: `}</Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Typography
                  variant="subtitle2"
                  color="textPrimary"
                >{`Para o Banner: `}</Typography>
                <Typography variant="caption" color="textSecondary">
                  {` Digite uma parte do nome da Imagem que você deseja vincular.`}
                </Typography>
                <hr />
                <Tooltip title={'courses.images.banner'}>
                  <ResourceSelector
                    fullWidth
                    label="Banner Hero"
                    source="contents.images[4].id"
                    resource="cms/content/images"
                    optionValue="id"
                    validate={[required('Obrigatório')]}
                    choicesFilter={{
                      target: 'type',
                      filter: 'banner',
                    }}
                  />
                </Tooltip>
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Tooltip title={'courses.images.banner.responsive'}>
                  <ResourceSelector
                    fullWidth
                    label="Banner Responsivo"
                    source="contents.images[3].id"
                    resource="cms/content/images"
                    optionValue="id"
                    validate={[required('Obrigatório')]}
                    choicesFilter={{
                      target: 'type',
                      filter: 'banner-responsive',
                    }}
                  />
                </Tooltip>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Tooltip title={'courses.images.banner-mobile'}>
                  <ResourceSelector
                    fullWidth
                    label="Banner Mobile"
                    source="contents.images[2].id"
                    resource="cms/content/images"
                    optionValue="id"
                    validate={[required('Obrigatório')]}
                    choicesFilter={{
                      target: 'type',
                      filter: 'banner-mobile',
                    }}
                  />
                </Tooltip>
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Tooltip title={'courses.images.banner-mobile'}>
                  <ResourceSelector
                    fullWidth
                    label="Banner Exercício de Conclusão"
                    source="contents.images[5].id"
                    resource="cms/content/images"
                    optionValue="id"
                    choicesFilter={{
                      target: 'type',
                      filter: 'conclusion-exercise',
                    }}
                  />
                </Tooltip>
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <hr />
                <Typography
                  variant="subtitle1"
                  color="textPrimary"
                  gutterBottom
                >{`Conteúdo do Banner: `}</Typography>
              </Grid>

              <Grid container spacing={2} direction="column">
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Typography
                    variant="subtitle2"
                    color="textPrimary"
                  >{`Para a Logo: `}</Typography>
                  <Typography variant="caption" color="textSecondary">
                    {` Digite uma parte do nome da Imagem que você deseja vincular.`}
                  </Typography>
                  <hr />
                  <Tooltip title={'courses.images.logo'}>
                    <ResourceSelector
                      fullWidth
                      label="Logo"
                      source="contents.images[1].id"
                      resource="cms/content/images"
                      optionValue="id"
                      validate={[required('Obrigatório')]}
                      choicesFilter={{
                        target: 'type',
                        filter: 'logo',
                      }}
                    />
                  </Tooltip>

                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => dispatch(actions.imagesDialog())}
                    >
                      Criar Nova Imagem
                    </Button>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Tooltip title={'courses.description'}>
                    <TextInput
                      fullWidth
                      label="Descrição"
                      source="description"
                      validate={[required('Obrigatório')]}
                    />
                  </Tooltip>
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Typography
                    variant="subtitle2"
                    color="textPrimary"
                  >{`Para o Trailer: `}</Typography>
                  <Typography variant="caption" color="textSecondary">
                    {` Digite uma parte do ID do Vídeo que você deseja vincular.`}
                  </Typography>
                  <hr />
                  <Typography variant="caption" color="textSecondary">
                    {` Para CRIAR um novo Vídeo clique no botão abaixo.`}
                  </Typography>
                </Grid>
                <Grid item spacing={2}>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Tooltip title={'courses.contents.videos.id'}>
                      <ResourceSelector
                        fullWidth
                        label="Trailer"
                        source={`contents.videos[0].id`}
                        resource="cms/content/videos"
                        optionValue="id"
                        choicesFilter={{
                          target: 'type',
                          filter: 'trailer',
                        }}
                      />
                    </Tooltip>
                  </Grid>

                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => dispatch(actions.videosDialog())}
                  >
                    Criar Novo Vídeo
                  </Button>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <hr />
                <Typography
                  variant="subtitle1"
                  color="textPrimary"
                  gutterBottom
                >{`Tópicos em destaque do Curso/Série (Bullets): `}</Typography>
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <hr />
                <Typography
                  variant="subtitle1"
                  color="textPrimary"
                  gutterBottom
                >{`Materiais: `}</Typography>
              </Grid>

              <Grid spacing={2} direction="row" container>
                {!!attachments.length &&
                  attachments.map((tag, index) => {
                    return (
                      <Grid key={index} container spacing={2}>
                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                          <Tooltip title={'courses.contents.attachments.id'}>
                            <ResourceSelector
                              fullWidth
                              label={`Material ${index + 1}`}
                              source={`contents.attachments[${index}].id`}
                              resource="cms/content/attachments"
                              optionValue="id"
                            />
                          </Tooltip>
                        </Grid>
                      </Grid>
                    )
                  })}

                <Grid
                  container
                  spacing={2}
                  className={classes.buttonsContainer}
                >
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() =>
                        setAttachments([...attachments, attachments.length + 1])
                      }
                    >
                      Vincular outro Material
                    </Button>
                  </Grid>

                  <Grid item>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => dispatch(actions.attachmentsDialog())}
                    >
                      Criar Novo Anexo
                    </Button>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <hr />
                  <Typography
                    variant="subtitle1"
                    color="textPrimary"
                    gutterBottom
                  >{`Pessoas Envolvidas: `}</Typography>
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Typography
                    variant="subtitle2"
                    color="textPrimary"
                  >{`Para a Pessoa Envolvida: `}</Typography>
                  <Typography variant="caption" color="textSecondary">
                    {` Digite uma parte do Nome da Pessoa que você deseja vincular.`}
                  </Typography>
                  <hr />
                  <Typography variant="caption" color="textSecondary">
                    {`Lembre-se de incluir um Autor quando selecionar a inclusão de um Curso.`}
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <FormDataConsumer subscription={{ values: true }}>
                    {({ formData, ...rest }) => {
                      const { catalog_type = 'serie' } = formData
                      const validate = catalog_type === 'case' ? true : false
                      return (
                        validate && (
                          <>
                            <Typography
                              variant="subtitle2"
                              color="textSecondary"
                              gutterBottom
                            >
                              {`Autor`}
                            </Typography>
                            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                              <ResourceSelector
                                fullWidth
                                label="Pessoas Envolvidas"
                                source={`contents.involved_people[0].id`}
                                resource="cms/content/involved_people"
                                optionValue="id"
                                validate={[required('Obrigatório')]}
                                choicesFilter={{
                                  target: 'type',
                                  filter: 'autor',
                                }}
                              />
                            </Grid>
                          </>
                        )
                      )
                    }}
                  </FormDataConsumer>
                </Grid>

                <Grid spacing={2} direction="row" container>
                  {!!involvedPersons.length &&
                    involvedPersons.map((tag, index) => {
                      return (
                        <Grid
                          key={index}
                          item
                          xs={12}
                          sm={12}
                          md={6}
                          lg={4}
                          xl={3}
                        >
                          <Typography
                            variant="subtitle2"
                            color="textSecondary"
                            gutterBottom
                          >
                            {`Pessoa envolvida – ${index + 1}`}
                          </Typography>
                          <Tooltip
                            title={'courses.contents.involved_people.id'}
                          >
                            <ResourceSelector
                              fullWidth
                              label="Pessoa Envolvida"
                              source={`contents.involved_people[${
                                index + 1
                              }].id`}
                              resource="cms/content/involved_people"
                              optionValue="id"
                            />
                          </Tooltip>
                        </Grid>
                      )
                    })}

                  <Grid
                    container
                    spacing={2}
                    className={classes.buttonsContainer}
                  >
                    <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() =>
                          setInvolvedPersons([
                            ...involvedPersons,
                            involvedPersons.length + 1,
                          ])
                        }
                      >
                        Vincular Nova Pessoa
                      </Button>
                    </Grid>

                    <Grid item>
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => dispatch(actions.personsDialog())}
                      >
                        Cria Nova Pessoa
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <hr />
                  <Typography
                    variant="subtitle1"
                    color="textPrimary"
                    gutterBottom
                  >{`Tags: `}</Typography>
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Typography
                    variant="subtitle2"
                    color="textPrimary"
                  >{`Para a Tag: `}</Typography>
                  <Typography variant="caption" color="textSecondary">
                    {` Digite uma parte do Nome da Tag que você deseja vincular. Obs: somente as duas primeiras tags aparecerão no card da home.`}
                  </Typography>
                  <hr />
                </Grid>

                <Grid spacing={2} direction="row" container>
                  {!!tags.length &&
                    tags.map((tag, index) => {
                      return (
                        <Grid
                          key={index}
                          item
                          xs={12}
                          sm={12}
                          md={6}
                          lg={4}
                          xl={3}
                        >
                          <Typography
                            variant="subtitle2"
                            color="textSecondary"
                            gutterBottom
                          >
                            {`Tag – ${index + 1}`}
                          </Typography>
                          <Tooltip title={'courses.tags_id'}>
                            <ResourceSelector
                              fullWidth
                              label="Tag"
                              source={`contents.tags[${index}].id`}
                              resource="cms/content/tags"
                              optionValue="id"
                              validate={[required('Obrigatório')]}
                            />
                          </Tooltip>
                        </Grid>
                      )
                    })}

                  <Grid
                    container
                    spacing={2}
                    className={classes.buttonsContainer}
                  >
                    <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => setTags([...tags, tags.length + 1])}
                      >
                        Vincular Nova Tag
                      </Button>
                    </Grid>

                    <Grid item>
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => dispatch(actions.tagsDialog())}
                      >
                        Cria Nova Tag
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  )
}
